module.exports = __webpack_public_path__ + "media/giftcards/GiftCards-Hero-Mobile-664c6e0e.jpg";